import { useCallback, useRef, useEffect } from 'react'

export function useActions(
  value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?],
  apiChange: (value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]) => void,
) {
  const fieldValueRef = useRef(value)
  useEffect(() => {
    fieldValueRef.current = value
  }, [value])

  const onDeleteAll = useCallback(() => {
    apiChange([])
  }, [apiChange])

  const onAddTimeWindow = useCallback(() => {
    const newTimeWindow = { startSec: 9 * 3600, endSec: 18 * 3600 } as uui.domain.rm.TimeWindow

    switch (fieldValueRef.current.length) {
      case 0:
        apiChange([newTimeWindow])
        break

      case 1:
        apiChange([fieldValueRef.current[0], newTimeWindow])
        break

      case 2:
        if (process.env.NODE_ENV === 'development') {
          throw new Error('Cannot add a new time window, time windows count limit is 2')
        }
        break
    }
  }, [apiChange])

  const onUpdateTimeWindow = useCallback(
    (timeWindow: uui.domain.rm.TimeWindow, timeWindowIndex: 0 | 1) => {
      const timeWindowTarget = fieldValueRef.current[timeWindowIndex]
      if (!timeWindowTarget) {
        if (process.env.NODE_ENV === 'development') {
          throw new Error('Cannot find the time window to update')
        }
        return
      }

      switch (timeWindowIndex) {
        case 0:
          const hasSecondValue = !!fieldValueRef.current[1]

          apiChange(hasSecondValue ? [timeWindow, fieldValueRef.current[1]] : [timeWindow])
          break

        case 1:
          if (!fieldValueRef.current[0]) {
            if (process.env.NODE_ENV === 'development') {
              throw new Error('Cannot find the time window')
            }
            break
          }

          apiChange([fieldValueRef.current[0], timeWindow])
          break
      }
    },
    [apiChange],
  )

  const onRemoveTimeWindow = useCallback(
    (timeWindowIndex: 0 | 1) => {
      const value = [...fieldValueRef.current] as [
        uui.domain.rm.TimeWindow?,
        uui.domain.rm.TimeWindow?,
      ]
      value.splice(timeWindowIndex, 1)
      apiChange(value)
    },
    [apiChange],
  )

  return {
    onDeleteAll,
    onAddTimeWindow,
    onUpdateTimeWindow,
    onRemoveTimeWindow,
  }
}
